import template from './template.html'

function ContabilidadPolizasexternasProvisionnominasconpagossucursalesListaComponent (ProvisionnominaconpagosSucursales, $filter, $file) {
  var $ctrl = this
  var verificarCadena = $filter('rPad')

  $ctrl.$onInit = function () {
    $ctrl.provision = []
    $ctrl.promise = ProvisionnominaconpagosSucursales.get($ctrl.nominas).then(function (resolve) {
      $ctrl.data = resolve.data
      $ctrl.provision = $filter('orderBy')($ctrl.data.provision, ['departamento'])
      $ctrl.pagos = $filter('orderBy')($ctrl.data.pagos)
      $ctrl.pagosexternos = $filter('orderBy')($ctrl.data.pagosexternos)
      $ctrl.polizas = [].concat($ctrl.data.polizas)
      $ctrl.cuentascontables = [].concat($ctrl.data.cuentascontables)
    })
  }

  $ctrl.descargar = function () {
    var texto = $ctrl.codificar(1)
    var fecha = $filter('date')(new Date(), 'yyyyMMdd')
    var nombre = 'ProvisionNominasPagosPorSucursales_' + fecha + '.txt'
    var blob = new File([texto], nombre, {type: 'text/plain'})
    $file.saveAs(blob, nombre)
  }

  $ctrl.codificar = function (inicio_poliza) {
    var cadenaPrincipal = '',
      cadA = 'P  AAAAMMDD    3      JJJJ 1 0          ' +
        'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX                                         11 1 0\r\n',
      cadB = 'M1 CCCCCCCCCCCCCCCC               ZZZZZZZZZZZZZZZ      * YYYYYYYYY            0          0.0' +
        '                  NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN \r\n',
      fecha_inicio = new Date(),
      fechaA = $filter('date')(fecha_inicio, 'yyyyMMdd'),
      fechaB = $filter('date')(fecha_inicio, 'dd/MM/yyyy'),
      vuelta = 0,
      posicion

    try {
      $ctrl.data.cuentascontables.forEach(function (item) {
        item.importe = 0
      })
      $ctrl.data.provision.forEach(function (nomina) {
        nomina.datos.forEach(function (item) {
          posicion = $ctrl.data.cuentascontables.findIndex(function (cuenta) {
            return (cuenta.cuentacontable + cuenta.concepto) === (item.cuentacontable + item.concepto)
          })
          if (posicion !== -1) {
            $ctrl.data.cuentascontables[posicion].importe += parseFloat(item.importe)
          }

          fechaA = $filter('date')(nomina.fecha_nomina, 'yyyyMMdd')
        })
      })

      $ctrl.data.provision.forEach(function (nomina) {
        nomina.datos.forEach(function (item) {
          if (vuelta === 0) {
            // fechaA = $filter("date")(empleado.fecha_nomina, "yyyyMMdd"),
            cadenaPrincipal += cadA
              .replace('AAAAMMDD', fechaA)
              .replace('JJJJ', ('000' + inicio_poliza).slice(-4))
              .replace('XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX', verificarCadena('Provision Nomina' + ' ' + item.id_nomina, 60))
          }

          fechaB = verificarCadena(item.id_nomina, 15)
          if (item.importe > 0) {
            cadenaPrincipal += cadB
              .replace('CCCCCCCCCCCCCCCC', verificarCadena(item.cuentacontable.replace(/-/g, ''), 16))
              .replace('ZZZZZZZZZZZZZZZ', fechaB)
              .replace('*', item.naturaleza === 'C' ? 0 : 1)
              .replace('YYYYYYYYY', verificarCadena((parseFloat(Math.abs(item.importe)).toFixed(2)), 9))
              .replace('NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN', verificarCadena((item.concepto), 43))
          }

          vuelta++
        })
      })

      $ctrl.data.pagos.forEach(function (item) {
        cadenaPrincipal += cadB
          .replace('CCCCCCCCCCCCCCCC', verificarCadena(item.Cuenta_Contable.replace(/-/g, ''), 16))
          .replace('ZZZZZZZZZZZZZZZ', verificarCadena(item.Fecha, 15))
          .replace('*', 1)
          .replace('YYYYYYYYY', verificarCadena((parseFloat(item.Importe).toFixed(2)), 9))
          .replace('NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN', verificarCadena(('Pago de Nomina'), 43))
        if (item.Importe_Complementario > 0) {
          cadenaPrincipal += cadB
            .replace('CCCCCCCCCCCCCCCC', verificarCadena(item.Cuenta_Contable_Complementaria.replace(/-/g, ''), 16))
            .replace('ZZZZZZZZZZZZZZZ', verificarCadena(item.Fecha, 15))
            .replace('*', 1)
            .replace('YYYYYYYYY', verificarCadena((parseFloat(item.Importe_Complementario).toFixed(2)), 9))
            .replace('NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN', verificarCadena(('Pago de Nomina'), 43))
        }
        cadenaPrincipal += cadB
          .replace('CCCCCCCCCCCCCCCC', verificarCadena(item.Cuenta_Contable_Banco.replace(/-/g, '')), 16)
          .replace('ZZZZZZZZZZZZZZZ', verificarCadena(item.Fecha, 15))
          .replace('*', 0)
          .replace('YYYYYYYYY', verificarCadena((parseFloat(item.Pago).toFixed(2)), 9))
          .replace('NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN', verificarCadena((item.Descripcion), 43))
      })

      $ctrl.data.pagosexternos.forEach(function (item, index) {
        if (index !== $ctrl.data.pagosexternos.length -1) {
          cadenaPrincipal += cadB
            .replace('CCCCCCCCCCCCCCCC', verificarCadena(item.Cuenta_Contable_Banco.replace(/-/g, ''), 16))
            .replace('ZZZZZZZZZZZZZZZ', verificarCadena(item.Fecha, 15))
            .replace('*', 0)
            .replace('YYYYYYYYY', verificarCadena((parseFloat(item.Importe)
              .toFixed(2)), 9))
            .replace('NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN', verificarCadena(('Pago de Nomina'), 43))
          if (item.Importe_Complementario > 0) {
            cadenaPrincipal += cadB
              .replace('CCCCCCCCCCCCCCCC', verificarCadena(item.Cuenta_Contable_Complementaria.replace(/-/g, ''), 16))
              .replace('ZZZZZZZZZZZZZZZ', verificarCadena(item.Fecha, 15))
              .replace('*', 1)
              .replace('YYYYYYYYY', verificarCadena((parseFloat(item.Importe_Complementario)
                .toFixed(2)), 9))
              .replace('NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN', verificarCadena(('Pago de Nomina'), 43))
          }
        } else {
          cadenaPrincipal += cadB
            .replace('CCCCCCCCCCCCCCCC', verificarCadena(item.Cuenta_Contable_Banco.replace(/-/g, '')), 16)
            .replace('ZZZZZZZZZZZZZZZ', verificarCadena(item.Fecha, 15))
            .replace('*', 1)
            .replace('YYYYYYYYY', verificarCadena((parseFloat(item.Pago)
              .toFixed(2)), 9))
            .replace('NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN', verificarCadena((item.Descripcion), 43))
        }
      })
      return cadenaPrincipal

    } catch (err) { // try
      return 'Error'
    }
  }

  $ctrl.filtrar = function () {
    $ctrl.provision = $filter('filter')($ctrl.data.provision, $ctrl.filtro)
    $ctrl.pagos = $filter('filter')($ctrl.data.pagos, $ctrl.filtro)
  }
}

angular.module('contabilidad.polizas')
  .component('contabilidadPolizasexternasProvisionnominasconpagossucursalesLista', {
    controller: ContabilidadPolizasexternasProvisionnominasconpagossucursalesListaComponent,
    template,
    bindings: {
      nominas: '<',
    },
  })



// WEBPACK FOOTER //
// ./src/contabilidad/polizasexternas/components/provisionnominasconpagossucursales/lista/component.js